import React from 'react';
import {Icon, Tooltip, HStack, Text} from '@chakra-ui/react';
import {Warning} from '@carbon/icons-react';
import _ from 'lodash';

export const BuilderPreviewValue = ({
  value,
  isStale,
}: {
  value: unknown;
  isStale?: boolean;
}) => {
  return (
    <HStack spacing={4} alignItems="flex-start">
      <Text>{_.isArray(value) ? value.join(', ') : _.toString(value)}</Text>
      {isStale && (
        <Tooltip
          label="Value is outdated, run preview to refresh"
          placement="left"
        >
          <Icon
            as={Warning}
            color="kred.400"
            boxSize="16px"
            flexShrink={0}
            mt="2px"
          />
        </Tooltip>
      )}
    </HStack>
  );
};
